var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DialogLayout',[_c('cropper',{on:{"change":function () {},"close":_vm.handleClose}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }